// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/style.css
// module id = 2678
// module chunks = 29